import { canv } from '@/canv/global.js'
import {toolBase} from '@/tools/toolBase';

import { reverseTransformPoint } from '@/canv/utils.js';
import { getViewport } from '@/canvasController/helpers';
import { selectionManager } from '../cursorTool';


export class clipTool extends toolBase {

    constructor() {
        super();
    }

    buildTool() {
    }

    initTool() {
    }

    select() {

        var clipToolMenu = document.createElement('div');
        clipToolMenu.classList.add("clipToolMenu");

        document.body.append(clipToolMenu);
        clipToolMenu.innerHTML = `
            <div class="clipToolMenuButton">
                <svg class="svg" width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.194 1.444L4.252 7.386.31 3.444l.884-.884 3.058 3.058L9.31.56l.884.884z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>
                <p>clip</p>
            </div>
        `;

        clipToolMenu.addEventListener('mousedown',  this.setWidgetClip.bind(this), false);

        this.TryLocateMenu();
    }

    unselect() {

        var clipToolMenu = document.getElementsByClassName("clipToolMenu")[0];
        if (clipToolMenu != undefined) {
            clipToolMenu.outerHTML = "";
        }

        var widget = canv.canvasController.FindByUID(this.widgetUID);
        if (widget == null) return;

        widget.isClipping = false;

        this.mode = "";
        this.widgetUID = "";

    }

    setupTool(data) {
        this.originalArea = data["originalArea"];

        this.clipX = data["clipArea"]["x"];
        this.clipY = data["clipArea"]["y"];
        this.clipWidth = data["clipArea"]["width"];
        this.clipHeight = data["clipArea"]["height"];

        this.widgetUID = data["UID"];
    }

    setWidgetClip() {
        var widget = canv.canvasController.FindByUID(this.widgetUID);
        if (widget == null) return;

        var clipOriginalDxShare = (this.clipX - this.originalArea["x"]) / this.originalArea["width"];
        var clipOriginalDyShare = (this.clipY - this.originalArea["y"]) / this.originalArea["height"];
        var clipOriginalWidthShare = this.clipWidth / this.originalArea["width"];
        var clipOriginalHeightShare = this.clipHeight / this.originalArea["height"];

        widget.setClip(clipOriginalDxShare, clipOriginalDyShare, clipOriginalWidthShare, clipOriginalHeightShare);
        var cursorTool = canv.toolBox.TryGetToolByName("cursorTool");
        canv.toolBox.switchTo(cursorTool);
        selectionManager.setSelected([widget.parent]);
    }



    TryAction(type) {

        if (type == "touchpadGestureDragging" || type == "touchpadGestureZoom") {
            this.TryLocateMenu();
        } else if (type == "mousedown") {

            if (this.isOverCatchers()) {
                this.mode = "resize";
            }

        } else if (type == "mousemove") {

            if (this.mode == "resize") {

                var pt = canv.actionManager.getActionPoint();
                var prePt = canv.actionManager.getPreActionPoint();

                var moveX = pt.x - prePt.x;
                var moveY = pt.y - prePt.y;

                if (this.catchPointer == "upLeft" || this.catchPointer == "bottomLeft") {
                    if (this.clipX + moveX >= this.originalArea["x"] && this.clipWidth - moveX > 2 * this.pointerSize) {
                        this.clipWidth += -moveX;
                        this.clipX += moveX;
                    }
                } else {
                    if (this.clipX + this.clipWidth + moveX <= this.originalArea["x"] + this.originalArea["width"] && this.clipWidth + moveX > 2 * this.pointerSize) {
                        this.clipWidth += moveX;
                    }
                }

                if (this.catchPointer == "upLeft" || this.catchPointer == "upRight") {
                    if (this.clipY + moveY >= this.originalArea["y"] && this.clipHeight - moveY > 2 * this.pointerSize) {
                        this.clipHeight += -moveY;
                        this.clipY += moveY;
                    }
                } else {
                    if (this.clipY + this.clipHeight + moveY <= this.originalArea["y"] + this.originalArea["height"] && this.clipHeight + moveY > 2 * this.pointerSize) {
                        this.clipHeight += moveY;
                    }
                }

                this.TryLocateMenu();

            }

        } else if (type == "mouseup") {

            this.mode = "";
        }

        canv.redraw();

    }




    // is

    isOverCatchers() {

        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;
        var y = pt.y;

        if (x > this.clipX - this.pointerSize/2 && x < this.clipX + this.pointerSize/2 && y > this.clipY - this.pointerSize/2 && y < this.clipY + this.pointerSize/2) {
            this.catchPointer = "upLeft";
            return true;
        }

        if (x > this.clipX + this.clipWidth - this.pointerSize/2 && x < this.clipX + this.clipWidth + this.pointerSize/2 && y > this.clipY - this.pointerSize/2 && y < this.clipY + this.pointerSize/2) {
            this.catchPointer = "upRight";
            return true;
        }


        if (x > this.clipX + this.clipWidth - this.pointerSize/2 && x < this.clipX + this.clipWidth + this.pointerSize/2 && y > this.clipY + this.clipHeight - this.pointerSize/2 && y < this.clipY + this.clipHeight + this.pointerSize/2) {
            this.catchPointer = "bottomRight";
            return true;
        }

        if (x > this.clipX - this.pointerSize/2 && x < this.clipX + this.pointerSize/2 && y > this.clipY + this.clipHeight - this.pointerSize/2 && y < this.clipY + this.clipHeight + this.pointerSize/2) {
            this.catchPointer = "bottomLeft";
            return true;
        }

        return false;
    }


    // locate menu

    TryLocateMenu() {

        var startX = this.clipX;
        var startY = this.clipY;
        var width = this.clipWidth;

        var menu = document.getElementsByClassName("clipToolMenu")[0];
        if (menu == undefined) {
            return;
        }

        var menuSize = menu.getBoundingClientRect();

        var xTarget = (startX + width / 2) * canv.m[0];
        var yTarget = startY * canv.m[3];

        var pt = reverseTransformPoint(xTarget, yTarget);

        var wantedX = pt.x - menuSize.width / 2;
        if (wantedX < 10)  wantedX = 10;
        if (wantedX + menuSize.width + 10 > canv.canvas.getBoundingClientRect().width)  wantedX = canv.canvas.getBoundingClientRect().width - menuSize.width - 10;
        menu.style.left = (wantedX).toString() + "px";

        var gap = 50; //  было 25
        var wantedY = pt.y - menuSize.height - gap;
        if (wantedY < 60)  wantedY = 60;
        if (wantedY + menuSize.height + 10 > canv.canvas.getBoundingClientRect().height)  wantedY = canv.canvas.getBoundingClientRect().height - menuSize.height - 10;
        menu.style.top = (wantedY).toString() + "px";

    }




    // DRAW

    draw() {
        this.drawClipArea();
        var memAlpha = canv.ctx.globalAlpha;
        canv.ctx.globalAlpha = 0.5;
        canv.ctx.fillStyle = "#E8EAF6";
        canv.ctx.fill();
        canv.ctx.globalAlpha = memAlpha;
        this.drawCatchPointer();
    }

    drawClipArea() {
        var viewport = getViewport();
        // Левый прямоугольник
        canv.ctx.beginPath()
        canv.ctx.moveTo(viewport["viewportStartX"], viewport["viewportStartY"]);
        canv.ctx.lineTo(this.clipX, viewport["viewportStartY"]);
        canv.ctx.lineTo(this.clipX, viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(viewport["viewportStartX"], viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(viewport["viewportStartX"], viewport["viewportStartY"]);

        // правый прямоугольник
        canv.ctx.moveTo(this.clipX + this.clipWidth, viewport["viewportStartY"]);
        canv.ctx.lineTo(viewport["viewportStartX"] + viewport["viewportWidth"], viewport["viewportStartY"]);
        canv.ctx.lineTo(viewport["viewportStartX"] + viewport["viewportWidth"], viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(this.clipX + this.clipWidth, viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(this.clipX + this.clipWidth, viewport["viewportStartY"]);

        // верхний прямоугольник
        canv.ctx.moveTo(this.clipX, viewport["viewportStartY"]);
        canv.ctx.lineTo(this.clipX + this.clipWidth, viewport["viewportStartY"]);
        canv.ctx.lineTo(this.clipX + this.clipWidth, this.clipY);
        canv.ctx.lineTo(this.clipX, this.clipY);
        canv.ctx.lineTo(this.clipX, viewport["viewportStartY"]);


        // нижний прямоугольник
        canv.ctx.moveTo(this.clipX, this.clipY + this.clipHeight);
        canv.ctx.lineTo(this.clipX + this.clipWidth, this.clipY + this.clipHeight);
        canv.ctx.lineTo(this.clipX + this.clipWidth, viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(this.clipX, viewport["viewportStartY"] + viewport["viewportHeight"]);
        canv.ctx.lineTo(this.clipX, this.clipY + this.clipHeight);
    }

    drawCatchPointer() {

        this.pointerSize = 12.5 / canv.m[0] * canv.dpr;

        if (this.pointerSize < 4) {
            this.pointerSize = 4;
        }


        if (this.pointerSize >= this.clipWidth || this.pointerSize >= this.clipHeight) {
            this.pointerSize = 4;
            return;
        }

        var pointerSize = this.pointerSize;
        canv.ctx.fillStyle = "white";
        canv.ctx.strokeStyle = "#0B99FF";
        canv.ctx.lineWidth = 2 / canv.m[0] * canv.dpr;

        var radius = 2.5;


        this.drawRoundedRect(this.clipX - pointerSize/2, this.clipY - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, true);
        this.drawRoundedRect(this.clipX - pointerSize/2, this.clipY - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, false);

        this.drawRoundedRect(this.clipX + this.clipWidth - pointerSize/2, this.clipY - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, true);
        this.drawRoundedRect(this.clipX + this.clipWidth - pointerSize/2, this.clipY - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, false);

        this.drawRoundedRect(this.clipX + this.clipWidth - pointerSize/2, this.clipY + this.clipHeight - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, true);
        this.drawRoundedRect(this.clipX + this.clipWidth - pointerSize/2, this.clipY + this.clipHeight - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, false);

        this.drawRoundedRect(this.clipX - pointerSize/2, this.clipY + this.clipHeight - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, true);
        this.drawRoundedRect(this.clipX - pointerSize/2, this.clipY + this.clipHeight - pointerSize/2, pointerSize, pointerSize, radius / canv.m[0] * canv.dpr, false);

    }

    drawRoundedRect(x, y, w, h, r, shouldFill) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, r);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, r);
        canv.ctx.arcTo(x,   y+h, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+w, y,   r);
        if (shouldFill) {
            canv.ctx.fill();
        } else {
            canv.ctx.stroke();
        }
        canv.ctx.closePath();
    }




    name = "clipTool";
    clipX = 0;
    clipY = 0;
    clipWidth = 0;
    clipHeight = 0;

    pointerSize = 0;
    catchPointer = "upLeft";

    mode = "";
    widgetUID = "";
}
